import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AuthenticationForm, TextField } from '../AuthenticationForm';
import { BirthdayField } from './BirthdayField';
import { ExternalLink } from '../ExternalLink';
import { withNamespaces } from 'react-i18next';
import Cookie from 'js-cookie';

const styles = (theme) => ({
  error: {
    color: 'red',
    position: 'absolute',
    top: '-10px'
  }
});

const SignUpFormComponent = ({ classes, openDialog, t, ...props }) => {
  // if user has set underage cookie, disable submit button
  const disableSubmit = !!Cookie.get('coppa_underage');
  
  return (
      <AuthenticationForm
        classes={{
          footer: classes.footer,
          submitWrapper: classes.submitWrapper,
        }}
        footer={
          <>
            <div className={classes.error}>{props.generalErrorMsg}</div>
            <div className={classes.footer__otherAccountPage}>
              {t('already_have_account', 'Already have an account')}{' '}
              <a onClick={(e) => openDialog(e, 'signIn')}>{t('sign_in')}</a>
            </div>
            <div className={classes.footer__terms}>
              <ExternalLink to="http://corporate.pluto.tv/privacy-policy">
                {`${t('privacy_policy')}, `}
              </ExternalLink>
              <ExternalLink to="http://corporate.pluto.tv/terms-of-use">
                {`${t('terms_of_service')}, `}
              </ExternalLink>
              <ExternalLink to="https://corporate.pluto.tv/cookie-policy/">
                {`${t('cookie_policy')}, `}
              </ExternalLink>
              {` ${t('and')} `}
              <ExternalLink to="https://viacomprivacy.com">
                {t('do_not_sell_my_personal_info')}
              </ExternalLink>
            </div>
          </>
        }
        disableSubmit={disableSubmit}
        noValidate
        {...props}
      >
        <TextField name="firstName" type="text" label={`${t('first_name')}`} required/>
        <TextField name="email" type="email" label={t('email_address').substring(1)} required />
        <TextField name="password" type="password" label={t('password')} required />
        <BirthdayField name="birthday" select label={t('birth_year')} required />
      </AuthenticationForm>
    );
  }

SignUpFormComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  onSocialAuth: PropTypes.func.isRequired,
  values: PropTypes.objectOf(PropTypes.string),
  openDialog: PropTypes.func.isRequired,
};
SignUpFormComponent.defaultProps = {
  values: null,
};

export const SignUpForm = withStyles(styles)(withNamespaces()(SignUpFormComponent));
